import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export class ReachableElement {
    public constructor(
        public id: string,
        public displayName: string,
        public icon: IconDefinition
    ) {}
}
